var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "client-switcher",
      class: { "client-switcher--collapsed": _vm.collapsed }
    },
    [
      _c(
        "button",
        {
          staticClass: "client-switcher__current",
          attrs: {
            type: "button",
            title: _vm.collapsed
              ? _vm.client.name || "Selecionar cliente"
              : null
          },
          on: { click: _vm.toggle }
        },
        [
          _c("span", { staticClass: "client-switcher__avatar" }, [
            _vm._v(_vm._s(_vm.initials(_vm.client.name)))
          ]),
          !_vm.collapsed
            ? _c("span", { staticClass: "client-switcher__meta" }, [
                _c("span", { staticClass: "client-switcher__name-row" }, [
                  _c("span", { staticClass: "client-switcher__name" }, [
                    _vm._v(_vm._s(_vm.client.name || "Selecionar cliente"))
                  ]),
                  _vm.isLead(_vm.client)
                    ? _c("span", { staticClass: "client-switcher__lead" }, [
                        _vm._v("Lead")
                      ])
                    : _vm._e()
                ]),
                _vm.clientSubtitle
                  ? _c("span", { staticClass: "client-switcher__sub" }, [
                      _vm._v(_vm._s(_vm.clientSubtitle))
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          !_vm.collapsed
            ? _c("icon-svg", {
                attrs: { name: "mdi-chevron-down", size: 16, color: _vm.navFg }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.open
        ? _c("div", { staticClass: "client-switcher__dropdown" }, [
            _c(
              "div",
              { staticClass: "client-switcher__search" },
              [
                _c("icon-svg", {
                  attrs: {
                    name: "status-search",
                    size: _vm.SEARCH_ICON_SIZE,
                    color: _vm.navFg
                  }
                }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.query,
                      expression: "query"
                    }
                  ],
                  staticClass: "client-switcher__input",
                  attrs: {
                    type: "text",
                    placeholder: "Buscar cliente ou código…"
                  },
                  domProps: { value: _vm.query },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.query = $event.target.value
                    }
                  }
                })
              ],
              1
            ),
            !_vm.query && _vm.recents.length
              ? _c("div", { staticClass: "client-switcher__section" }, [
                  _vm._v("Recentes")
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "client-switcher__list" },
              [
                _vm._l(_vm.list, function(c) {
                  return _c(
                    "button",
                    {
                      key: c.id,
                      staticClass: "client-switcher__option",
                      class: {
                        "client-switcher__option--current":
                          c.id === _vm.client.id
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.pick(c)
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "client-switcher__avatar client-switcher__avatar--sm"
                        },
                        [_vm._v(_vm._s(_vm.initials(c.name)))]
                      ),
                      _c("span", { staticClass: "client-switcher__opt-name" }, [
                        _vm._v(_vm._s(c.name))
                      ]),
                      _vm.isLead(c)
                        ? _c("span", { staticClass: "client-switcher__lead" }, [
                            _vm._v("Lead")
                          ])
                        : _vm._e(),
                      c.id === _vm.client.id
                        ? _c("icon-svg", {
                            attrs: {
                              name: "check-circle",
                              size: 16,
                              color: "primary"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                }),
                _vm.query && !_vm.list.length
                  ? _c("div", { staticClass: "client-switcher__empty" }, [
                      _vm._v(" Nenhum cliente encontrado. ")
                    ])
                  : _vm._e()
              ],
              2
            ),
            _c(
              "button",
              {
                staticClass: "client-switcher__all",
                attrs: { type: "button" },
                on: { click: _vm.openAll }
              },
              [_vm._v(" Ver todos os clientes ")]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }